import { BaseRestDataProvider } from './BaseRestDataProvider';


export class ExcelExportRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/excelexport');
  }

  //get pricing method which returns a downloaded excel file
  async downloadPricing(scenarioGuid: string, projectGuid : string): Promise<Blob> {
    const response = await this.getBlob('/pricing/' + projectGuid + '/' + scenarioGuid);
    return response;
  }
}

